// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"06fb50c2","977":"2417ce42"}[chunkId] + ".chunk.js";
};